export interface IOpenChartData {
	Month: number;
	Open: number;
}
export class ChartOpenByMonth {
	public Open: number[] = [];

	constructor(data?: IOpenChartData[]) {
		for (let i = 0; i < 12; i++) {
			this.Open.push(0);
		}
		if (!data) {
			return;
		}
		for (let open of data) {
			this.Open[open.Month - 1] = open.Open;
		}
	}

	public getOrderedData(startMonth: number): number[] {
		let arr = [];
		for (let i = 0; i < 12; i++) {
			let endIndex = i - startMonth;
			if (endIndex < 0) {
				endIndex += 12;
			}
			arr[endIndex] = Math.round(this.Open[i]);
		}
		return arr;
	}
}
